// POSSIBLE - The regex that is used to determine a possible tag and trigger the suggestion popover
// PASTE - The regex used to find all global matches in a pasted string
// LEX - The regex used by the lexer to find the first match in a string

// Valid characters for any user type are alphanumeric, period, hyphen, apostrophe, and accented characters
const dottedUserset = "[.\\w-'ŽžÀ-ÿ¨´ˆ]"; // Checks for usernames
const userset = "[\\w-'ŽžÀ-ÿ¨´ˆ]"; // Does not include a . character when searching via first and last name with a space

// Valid characters hashtags are same as users, without periods or underscores
const hashset = "[.A-Za-z0-9-'ŽžÀ-ÿ¨´ˆ]";

export const matchers = {
	amount: {
		lex: /^\+\d+/,
		paste: /\+\d+/g,
		possible: /\d*/,
	},
	emoji: {
		possible: /[\w-]*/,
	},
	hashtag: {
		// Match a valid hashtag at the beginning of a string with at least one character
		lex: new RegExp(`^#${hashset}+`),
		// Match a hashtag anywhere in a string
		paste: new RegExp(`#${hashset}+`, 'g'),
		// Match 0 or more valid hashtag characters without the #
		possible: new RegExp(`${hashset}*`),
	},
	mention: {
		// Match a valid user search at the beginning of a string with at least one character
		lex: new RegExp(`^&${dottedUserset}+`),
		// Match a user search anywhere in a string
		paste: new RegExp(`&${dottedUserset}+`, 'g'),
		// Match 0 or more valid characters in addition an optional space
		possible: new RegExp(`${dottedUserset}* ?${dottedUserset}*`),
	},
	recipient: {
		// Match a valid user search or email at the beginning of a string with at least one character
		lex: new RegExp(`^@${dottedUserset}+`),
		// Match a user search or email anywhere in a string
		paste: new RegExp(`(?<!\\w)@${dottedUserset}+`, 'g'),
		possible: [
			// There are many possible matches for a recipient so we need to check for them one at a time
			new RegExp(`${dottedUserset}*`), // Match a username (user.name)
			new RegExp(`@${dottedUserset}*`), // Match a username (@user.name)
			new RegExp(`${userset}* ?${userset}*`), // Match a user's full name
		],
	},
	text: {
		lex: /^[^#@+&]+/,
	},
};
